import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'

import { Card, CardHeader, CardText, CardActions } from 'material-ui/Card'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import RaisedButton from 'material-ui/RaisedButton'
import Refresh from 'material-ui/svg-icons/navigation/refresh'

import { setSnackbarMessage } from '../../../actions/snackbar'
import api from '../../../api'
import store from '../../../store'
import {
  formatGroup,
  formatMembers,
  formatSentDate,
  formatStatus
} from './formatters'

const CommentBotRunSummary = ({ commentBotRun }) => {
  return (
    <Card>
      <CardHeader title='Summary' />
      <CardText>
        <Table selectable={false}>
          <TableBody displayRowCheckbox={false}>
            <TableRow>
              <TableRowColumn>Date Sent</TableRowColumn>
              <TableRowColumn>Reminder Name</TableRowColumn>
              <TableRowColumn>Session</TableRowColumn>
              <TableRowColumn>Group</TableRowColumn>
              <TableRowColumn>Members</TableRowColumn>
              <TableRowColumn>Status</TableRowColumn>
            </TableRow>
            <TableRow>
              <TableRowColumn>
                {formatSentDate(commentBotRun.date_sent)}
              </TableRowColumn>
              <TableRowColumn>{commentBotRun.name}</TableRowColumn>
              <TableRowColumn>{commentBotRun.session.name}</TableRowColumn>
              <TableRowColumn>
                {formatGroup(commentBotRun.group && commentBotRun.group.name)}
              </TableRowColumn>
              <TableRowColumn>
                {formatMembers(null, commentBotRun)}
              </TableRowColumn>
              <TableRowColumn>
                {formatStatus(commentBotRun.status)}
              </TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>

        {commentBotRun.status === 'FAILED' && (
          <Card>
            <CardHeader title='Run Failure' />
            <CardText>{commentBotRun.error_message}</CardText>
            <CardActions>
              <RaisedButton
                label='Retry'
                onClick={() => {
                  api
                    .post(`admin/comment_bot_runs/${commentBotRun.id}/retry`)
                    .then((res) => {
                      if (!res.ok) {
                        return store.dispatch(
                          setSnackbarMessage(
                            'Encountered unexpected error while attempting to schedule run to be retried'
                          )
                        )
                      }

                      store.dispatch(
                        setSnackbarMessage('Scheduled run to be retried')
                      )
                      browserHistory.push('/write-now/comment-bots/history')
                    })
                }}
                icon={<Refresh />}
                primary
              />
            </CardActions>
          </Card>
        )}

        {commentBotRun.status === 'COMPLETE' && (
          <Card>
            <CardHeader title='Run Statistics' />
            <CardText>
              <Table selectable={false}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                  <TableRow>
                    <TableHeaderColumn>Stat</TableHeaderColumn>
                    <TableHeaderColumn>Value</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                  <TableRow key='total-groups'>
                    <TableRowColumn>Total Groups</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.totalGroups}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='groups-processed'>
                    <TableRowColumn>Groups Processed</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.groupsProcessed}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='total-members'>
                    <TableRowColumn>Total Members</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.totalMembers}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='empty-checkins'>
                    <TableRowColumn>Members With Empty Checkins</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.membersWithEmptyCheckin}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='partial-checkins'>
                    <TableRowColumn>
                      Members With Partial Checkins
                    </TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.membersWithPartialCheckin}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='complete-checkins'>
                    <TableRowColumn>
                      Members With Complete Checkins
                    </TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.membersWithCompleteCheckin}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='checkins-created'>
                    <TableRowColumn>Checkins Created</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.checkinsCreated}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='checkins-existed'>
                    <TableRowColumn>Checkins Existing</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.checkinsExisting}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='comments-created'>
                    <TableRowColumn>Comments Created</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.commentsCreated}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='email-notifications-queued'>
                    <TableRowColumn>Email Notifications Queued</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.emailNotificationsQueued}
                    </TableRowColumn>
                  </TableRow>
                  <TableRow key='email-notifications-sent'>
                    <TableRowColumn>Email Notifications Sent</TableRowColumn>
                    <TableRowColumn>
                      {commentBotRun.run_stats.emailNotificationsSent}
                    </TableRowColumn>
                  </TableRow>
                </TableBody>
              </Table>
            </CardText>
          </Card>
        )}
      </CardText>
    </Card>
  )
}

// @ts-ignore
CommentBotRunSummary.propTypes = {
  commentBotRun: React.PropTypes.object
}

// @ts-ignore
export default connect(null, { setSnackbarMessage })(CommentBotRunSummary)
